(() => {
  const SUPPRESSION_PREFIX = 'wth-free-gift-suppressed:';

  const isSuppressed = triggerProductId => {
    try {
      return sessionStorage.getItem(`${SUPPRESSION_PREFIX}${triggerProductId}`) === 'true';
    } catch (error) {
      return false;
    }
  };

  const suppress = triggerProductId => {
    try {
      sessionStorage.setItem(`${SUPPRESSION_PREFIX}${triggerProductId}`, 'true');
    } catch (error) {
      // Storage can be unavailable in privacy modes; cart behaviour still works.
    }
  };

  let syncing = false;

  const syncCart = async () => {
    if (syncing) return;
    syncing = true;

    try {
      const cartResponse = await fetch(`${KROWN.settings.routes.cart_url}.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!cartResponse.ok) throw new Error('Unable to read cart');

      const cart = await cartResponse.json();
      const triggers = new Map();
      const gifts = new Map();
      const updates = {};

      document.querySelectorAll('[data-js-cart-item][data-free-gift-variant]').forEach(item => {
        triggers.set(String(item.dataset.productId), Number(item.dataset.freeGiftVariant));
      });

      cart.items.forEach(item => {
        const properties = item.properties || {};
        if (properties._free_gift === 'true') {
          const triggerProductId = String(properties._free_gift_trigger || '');
          if (!triggerProductId || gifts.has(triggerProductId)) {
            updates[item.key] = 0;
          } else {
            gifts.set(triggerProductId, item);
          }
          return;
        }

        if (properties._free_gift_variant) {
          triggers.set(String(item.product_id), Number(properties._free_gift_variant));
        }
      });

      gifts.forEach((gift, triggerProductId) => {
        if (!triggers.has(triggerProductId)) {
          updates[gift.key] = 0;
        } else if (Number(gift.variant_id) !== triggers.get(triggerProductId)) {
          updates[gift.key] = 0;
          gifts.delete(triggerProductId);
        } else if (gift.quantity !== 1) {
          updates[gift.key] = 1;
        }
      });

      const additions = [];
      triggers.forEach((giftVariantId, triggerProductId) => {
        if (!gifts.has(triggerProductId) && !isSuppressed(triggerProductId)) {
          additions.push({
            id: giftVariantId,
            quantity: 1,
            properties: {
              _free_gift: 'true',
              _free_gift_trigger: triggerProductId
            }
          });
        }
      });

      let changed = false;
      if (Object.keys(updates).length > 0) {
        const updateResponse = await fetch(`${KROWN.settings.routes.cart_update_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates })
        });
        if (!updateResponse.ok) throw new Error('Unable to update free gifts');
        changed = true;
      }

      if (additions.length > 0) {
        const addResponse = await fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: additions })
        });
        if (!addResponse.ok) throw new Error('Free gift is no longer available');
        changed = true;
      }

      if (changed) {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else if (window.refreshCart) {
          window.refreshCart();
        }
      }
    } catch (error) {
      console.warn('[WTH Free Gift]', error.message);
    } finally {
      syncing = false;
    }
  };

  window.WTHFreeGift = { suppress, syncCart };
  document.addEventListener('DOMContentLoaded', syncCart, { once: true });
})();
